<template>
	<div>
		<div style="display: flex;width: 800px;">
		</div>
	</div>
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	import { mapState } from 'vuex'; // 引入 全局 公共数据
	export default {
		mixins: [common], // 引入mixins里的common.js
		inject: ['layout'], // 依赖注入
		// 引入注册
		components: {
			buttonSearch
		},
		data() {
			return {
				
			}
		},
		created() {
			this.ces()
		},
		methods: {
			ces(){
				let a = {
					asd:1,
					sads:2,
					time:3123
				}
				let {time,asd, ...data} = a
				console.log(data)
			},
		},
	}
</script>

<style>
</style>
